<template>
  <div class="about">
    <h1>A site for event to better the world.</h1>
  </div>
</template>
